import { http } from '@/app/lib/http/client'

export type RuleEffect = 'include' | 'exclude'

export interface UseCaseRule {
  id: number
  name: string
  priority: number
  effect?: RuleEffect
  sku?: string
}

export interface ProductUseCase {
  id: number
  name: string
  slug: string
  description?: string | null
  is_active: boolean
  sort_order: number
  categories?: Array<{ id: number; name: string; pivot: { priority: number } }>
  departments?: Array<{ id: number; name: string; pivot: { priority: number } }>
  product_types?: Array<{ id: number; name: string; pivot: { priority: number } }>
  product_overrides?: Array<{
    id: number
    name: string
    sku: string
    pivot: { effect: RuleEffect; priority: number }
  }>
  categories_count?: number
  departments_count?: number
  product_types_count?: number
  product_overrides_count?: number
}

export interface UseCasePayload {
  name: string
  description: string
  is_active: boolean
  sort_order: number
  categories: Array<{ id: number; priority: number }>
  departments: Array<{ id: number; priority: number }>
  product_types: Array<{ id: number; priority: number }>
  products: Array<{ id: number; effect: RuleEffect; priority: number }>
}

export const useCaseService = {
  async list(params: Record<string, string | number | boolean> = {}) {
    return (await http.get('/use-cases', { params })).data.data
  },
  async get(id: number) {
    return (await http.get(`/use-cases/${id}`)).data.data as ProductUseCase
  },
  async create(payload: UseCasePayload) {
    return (await http.post('/use-cases', payload)).data.data as ProductUseCase
  },
  async update(id: number, payload: UseCasePayload) {
    return (await http.put(`/use-cases/${id}`, payload)).data.data as ProductUseCase
  },
  async updateStatus(id: number, isActive: boolean) {
    return (await http.patch(`/use-cases/${id}/status`, { is_active: isActive })).data.data
  },
  async remove(id: number) {
    return http.delete(`/use-cases/${id}`)
  },
  async preview(id: number, page = 1, search = '') {
    return (await http.get(`/use-cases/${id}/products`, { params: { page, search } })).data.data
  },
}
